import { Suspense } from "react";
import { JSX } from "react";

import { useLanguage } from "@4pace-cpq/core";
import { Box } from "@mui/material";
import {
  CommonErrorBoundary,
  DateLocalizationProvider,
  OAuthManager,
} from "@plansoft-configuration-renderer/components";
import { GatewayDest } from "@plansoft-configuration-renderer/gateway";

import { CFGObjectSelect } from "./renderer/CFGObjectSelect";
import { MinimalAppContext } from "./renderer/MinimalAppContext";
import { MinimalRenderer } from "./renderer/MinimalRenderer";
import { CadStatusProvider } from "./renderer/customContext/CadStatusContext";

const CONFIGURATOR_BASE_URL = "/preview";

export function Configurator({
  cfgObjectId,
  state,
  /* productSelection, */
}: {
  cfgObjectId?: string;
  state?: string;
  productSelection?: string;
}): JSX.Element {
  const { selectedLanguage } = useLanguage();
  const languageCode = selectedLanguage?.languageCode ?? "en-US";

  return (
    <CadStatusProvider>
      <MinimalAppContext>
        <CommonErrorBoundary>
          <Suspense>
            <DateLocalizationProvider localeCode={languageCode}>
              <Box pb={{ xs: 24, md: 16 }} paddingInline={"4vw"}>
                <Box sx={{ position: "sticky", top: 0, maxHeight: "90vh" }}>
                  <GatewayDest name="navigation" />
                </Box>
                {cfgObjectId ? (
                  <MinimalRenderer
                    baseUrl={CONFIGURATOR_BASE_URL}
                    cfgObjectId={cfgObjectId}
                    /* productSelection={productSelection} */
                    language={languageCode}
                    state={state}
                  />
                ) : (
                  <CFGObjectSelect />
                )}
                <OAuthManager
                  basePath={CONFIGURATOR_BASE_URL}
                  isLocalDevelopment={import.meta.env.DEV}
                />
              </Box>
            </DateLocalizationProvider>
          </Suspense>
        </CommonErrorBoundary>
      </MinimalAppContext>
    </CadStatusProvider>
  );
}
